import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { CarCare } from "../types";
import {
	getCarCaresAsync,
	getCarCareDetailsAsync,
	GetCarCaresAsyncPayload,
	GetCarCareDetailsPayload,
	setCarCares,
	CreateCarCarePayload,
	createNewCarCareAsync,
	setCarCare,
	updateCarCareAsync,
	UpdateCarCarePayload,
} from "./car-care.slice";

// Get list
function* getCarCaresSaga(action: PayloadAction<GetCarCaresAsyncPayload>) {
	const { query, callback } = action.payload;
	const skip = query.skip * (query.take || 0);
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CarCare[]>>(
				"/dashboard/car-washes",
				{
					...query,
					skip
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setCarCares.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetCarCares() {
	yield takeLatest(getCarCaresAsync, getCarCaresSaga);
}

// Get carCare details
function* getCarCareDetailsSaga(
	action: PayloadAction<GetCarCareDetailsPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CarCare>>(
				`/dashboard/car-washes/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setCarCare.type, payload: response });
		callback?.(response.data);
	} else {
		message.error(translate(error.message));
	}
}

function* watchCarCareDetails() {
	yield takeLatest(getCarCareDetailsAsync, getCarCareDetailsSaga);
}

// Create new carCare
function* createNewCarCareSaga(action: PayloadAction<CreateCarCarePayload>) {
	const { data, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post(
				"/dashboard/car-washes",
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateCarCare() {
	yield takeLatest(createNewCarCareAsync, createNewCarCareSaga);
}

// Update part type
function* updateCarCareSaga(action: PayloadAction<UpdateCarCarePayload>) {
	const { data, id, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/dashboard/car-washes/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: getCarCareDetailsAsync.type, payload: {id } });
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateCarCare() {
	yield takeLatest(updateCarCareAsync, updateCarCareSaga);
}

const carCareSaga = [
	watchGetCarCares(),
	watchCarCareDetails(),
	watchCreateCarCare(),
	watchUpdateCarCare(),
];
export default carCareSaga;
